import React from "react";
type UserProps = React.PropsWithChildren<{}>;
function User(props: UserProps) {
	return <div className="h-full">{props.children}</div>;
}

export default User;
